<template>
  <div v-tooltip="{ title: tooltip, delay: 250, placement: 'left', positionFixed: true, trigger: 'hover', touch: false }" :class="`card__badge--${color || 'mint'}`" class="card__badge">
    <slot/>
  </div>
</template>

<script>

export default {
  name: 'CardBadge',

  props: {
    tooltip: String,
    color: String,
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~styles/import';

.card {
  &__badge {
    background-color: $mint;
    position: absolute;
    top: -20px;
    right: 34px;
    padding: 8px 16px;
    border-radius: 16px;
    color: white;
    font-weight: bold;
    white-space: nowrap;
    transform: rotate(7deg);
    z-index: 2;

    &--orange {
      background-color: $orange;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/CardBadge.vue